import { Box } from "@mui/joy";
import { Outlet, useLocation } from "react-router";

import { motion } from "framer-motion";
import { useContext, useEffect, useRef } from "react";
import Sidebar from "../components/ui/Sidebar";
import Header from "../components/ui/Header";
import { LayoutContext } from "../context";



export default function Layout() {
    const location = useLocation();
    const { account, isPatient } = useContext(LayoutContext);

    useEffect(() => {
      // Выполняется каждый раз, когда изменяется текущий путь
      console.log("Путь изменился на:", location.pathname);
  
      // Вы можете добавить дополнительные действия здесь
    }, [location]);

    const scrollContainerRef = useRef(null); // Референс на блок для прокрутки

    
    return (
        <Box sx={{ display: 'flex', height: '100dvh' }}>
            { account && !isPatient && (
                <Sidebar/>
            )}
            <Box
                sx={{
                    height: '100%',
                    width: '100%'
                }}
            >
                { account && !isPatient && (
                    <Header/>
                )}
                <Box
                    // ref={scrollContainerRef}
                    className="MainContent"
                    sx={{
                        overflowY: 'scroll',
                        overflowX: 'hidden',
                        mt: {
                            xs: account && !isPatient ? 'calc(0px + var(--Header-height))' : 0,
                            sm: account && !isPatient ? 'calc(0px + var(--Header-height))' : 0,
                            md: 0,
                        },
                        // pb: { xs: 2, sm: 2, md: 3 },

                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: 0,
                        gap: 1,
                        height: { xs: 'calc(100dvh - var(--Header-height))', md: '100dvh' }
                    }}
                >
                    <motion.main
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 40 }}
                    >
                        <Outlet context={{ scrollContainerRef }}/>
                    </motion.main>
                </Box>
            </Box>
        </Box>
    );
}